//@ts-ignore
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
import { useState } from "react";

const EditShiftComponent = loadable(
  () => import("../../components/Shift/EditShift")
);
const EditShift = () => {
  const { id } = useParams();

  const {
    data: shift,
    refetch,
    isLoading,
  } = useGetHook({
    queryKey: ["shift", `shift-${id}`],
    url: `${APIS.SHIFT}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["shift"],
    navigateURL: "/human-resource-management/shift",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.SHIFT}${id}/`;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      toast.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Shift</span>
      </div>
      <EditShiftComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        profile={shift}
        refetch={refetch}
      />
    </>
  );
};
export default EditShift;
